import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings, Fonts } from '@styles/index';
import { getTime, getIsLive } from '../scheduleHelper';
import ScheduleCard from '../ScheduleCard';

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  border-bottom: ${Spacings.SPACING_2} solid
    ${({ $hasLiveClass }) =>
      $hasLiveClass ? 'var(--color-i-red)' : 'var(--color-divider)'};
  grid-template-columns: 65px 1fr;
  grid-column-gap: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
`;

const Time = styled.span`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.H6};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ $hasLiveClass }) =>
    $hasLiveClass ? 'var(--color-i-red)' : 'var(--color-i-violet-7)'};
`;

const ScheduleRowMobile = ({ data }) => {
  const hasLiveClass = getIsLive(data);
  return (
    <Wrapper $hasLiveClass={hasLiveClass}>
      <Time $hasLiveClass={hasLiveClass}>
        {`${getTime(data.live_at, 'hrs')} : ${getTime(data.live_at)}`}
      </Time>
      <ScheduleCard data={data} />
    </Wrapper>
  );
};

ScheduleRowMobile.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired
};

export default ScheduleRowMobile;
